// extracted by css-extract-rspack-plugin
export default {"ListItem":"uvRZc","ListItemLabel":"d0R_H","SegmentedControlLabel":"OYhPS"};